export default "__VITE_ASSET__1yG9IGhL__"